// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mHpIrbOufJ {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.mHpIrbOufJ h4 {
  line-height: 3em;
}
.mHpIrbOufJ .s6PT3m60a1 {
  float: left;
  width: 100%;
}
.mHpIrbOufJ .WLwQT6grf6 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.mHpIrbOufJ .WLwQT6grf6:hover {
  cursor: pointer;
}
.mHpIrbOufJ .WLwQT6grf6:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.Cl36s1h5O4 .GKIDD8_ibm:focus {
  outline: none;
}
.Cl36s1h5O4 .GKIDD8_ibm.ehIV1qbPXU.pNC1sqolsn {
  background: #375A88;
}
.Cl36s1h5O4 .GKIDD8_ibm.ehIV1qbPXU.pNC1sqolsn span {
  color: #fff;
}
.Cl36s1h5O4 .pNC1sqolsn {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.Cl36s1h5O4 .pNC1sqolsn:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.Cl36s1h5O4 input {
  height: 38px;
  min-width: 220px;
}
.WLwQT6grf6.tvd0GBCwHm {
  background: #410102;
}
.WLwQT6grf6.IlP93xj77H {
  background: #911318;
}
.WLwQT6grf6.wHsGerUvNT {
  background: #D8293B;
}
.WLwQT6grf6.OjSLijc7VF {
  background: #F2373C;
}
.WLwQT6grf6.RJfX8hgqbW {
  background: #FC4448;
}
.WLwQT6grf6.dbSYUOJ6od {
  background: #ED535E;
}
.WLwQT6grf6.HFIYLAdJ52 {
  background: #E34926;
}
.WLwQT6grf6.alF5EmUpNH {
  background: #FC562B;
}
.WLwQT6grf6.sMOkhBOqMS {
  background: #FC6722;
}
.WLwQT6grf6.kcbrjqHSNo {
  background: #FD7F24;
}
.WLwQT6grf6.MS9s5253a3 {
  background: #FD8D26;
}
.WLwQT6grf6.CAPbAk4GLA {
  background: #EC9C3E;
}
.WLwQT6grf6.t2wfJSY3Uj {
  background: #0e673a;
}
.WLwQT6grf6.uWx9N5cPWA {
  background: #208740;
}
.WLwQT6grf6.ZTQQhvzahq {
  background: #239718;
}
.WLwQT6grf6.squ1DRGTQD {
  background: #55A84D;
}
.WLwQT6grf6.C7_4yUXoMO {
  background: #4BBE5A;
}
.WLwQT6grf6.omURZW13J7 {
  background: #0CCA6A;
}
.WLwQT6grf6.qTQk5JXTLm {
  background: #0A3C64;
}
.WLwQT6grf6.pwsYwp5DcC {
  background: #0d487a;
}
.WLwQT6grf6.WR1nK9Eg_y {
  background: #10538d;
}
.WLwQT6grf6.a1AThM5gEr {
  background: #115A99;
}
.WLwQT6grf6.q7yjiSIdWT {
  background: #3387E2;
}
.WLwQT6grf6.vgrM5dmfB2 {
  background: #1BA9CF;
}
.WLwQT6grf6.OWGDnVVuro {
  background: #d27c02;
}
.WLwQT6grf6.L7GwLBCUe3 {
  background: #fb9402;
}
.WLwQT6grf6.ASMR1UHn5d {
  background: #FD9B30;
}
.WLwQT6grf6.xhoAFit2mU {
  background: #FDBE2D;
}
.WLwQT6grf6.GskQ7FcTMl {
  background: #FED831;
}
.WLwQT6grf6.Kgvxuxcs44 {
  background: #FFFD38;
}
.WLwQT6grf6.XeUPiPs73l {
  background: #2D215C;
}
.WLwQT6grf6.feML9hLjvD {
  background: #483C83;
}
.WLwQT6grf6.iKiDNVvcsv {
  background: #58518d;
}
.WLwQT6grf6.pNWQ3fB0Kj {
  background: #7068A9;
}
.WLwQT6grf6.qzsQS9ji9H {
  background: #7f78b2;
}
.WLwQT6grf6.eNbG0PckOf {
  background: #8f88bc;
}
.WLwQT6grf6.EIwC1xt3kU {
  background: #000;
}
.WLwQT6grf6.M0CofJltzA {
  background: #282626;
}
.WLwQT6grf6.JSvGM1GWIx {
  background: #242222;
}
.WLwQT6grf6.lE_XW6QjMB {
  background: #353838;
}
.WLwQT6grf6.I3MGLpQcOe {
  background: #666;
}
.WLwQT6grf6.jKP9Pvhsb9 {
  background: #999;
}
.HZOTGF3200 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.HZOTGF3200 .HYkXp3xDpr {
  display: none;
}
.qqJz55Erqe {
  width: 100%;
}
.hVMMFXWvOH .UvAxKs8cBk.UvAxKs8cBk {
  align-items: center;
  background-color: #fff !important;
  background: #fff !important;
  color: #211E27 !important;
  display: flex;
  font-size: 11px;
  font-weight: 400;
  height: 36px;
  justify-content: flex-start;
  letter-spacing: 0px;
  margin: 0px;
  padding: 12px;
  text-transform: capitalize;
  width: 100%;
}
.hVMMFXWvOH .UvAxKs8cBk.UvAxKs8cBk:hover {
  color: #027391 !important;
  background-color: #f5f6f7 !important;
}
.hVMMFXWvOH .XzDV752Tab {
  margin-right: 8px;
}
.hVMMFXWvOH:not(:first-child) {
  border-top: solid 1px #e5e5e5;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `mHpIrbOufJ`,
	"color-row": `s6PT3m60a1`,
	"color-tile": `WLwQT6grf6`,
	"picker-component": `Cl36s1h5O4`,
	"picker-element": `GKIDD8_ibm`,
	"active": `ehIV1qbPXU`,
	"btn": `pNC1sqolsn`,
	"red-1": `tvd0GBCwHm`,
	"red-2": `IlP93xj77H`,
	"red-3": `wHsGerUvNT`,
	"red-4": `OjSLijc7VF`,
	"red-5": `RJfX8hgqbW`,
	"red-6": `dbSYUOJ6od`,
	"orange-1": `HFIYLAdJ52`,
	"orange-2": `alF5EmUpNH`,
	"orange-3": `sMOkhBOqMS`,
	"orange-4": `kcbrjqHSNo`,
	"orange-5": `MS9s5253a3`,
	"orange-6": `CAPbAk4GLA`,
	"green-1": `t2wfJSY3Uj`,
	"green-2": `uWx9N5cPWA`,
	"green-3": `ZTQQhvzahq`,
	"green-4": `squ1DRGTQD`,
	"green-5": `C7_4yUXoMO`,
	"green-6": `omURZW13J7`,
	"blue-1": `qTQk5JXTLm`,
	"blue-2": `pwsYwp5DcC`,
	"blue-3": `WR1nK9Eg_y`,
	"blue-4": `a1AThM5gEr`,
	"blue-5": `q7yjiSIdWT`,
	"blue-6": `vgrM5dmfB2`,
	"yellow-1": `OWGDnVVuro`,
	"yellow-2": `L7GwLBCUe3`,
	"yellow-3": `ASMR1UHn5d`,
	"yellow-4": `xhoAFit2mU`,
	"yellow-5": `GskQ7FcTMl`,
	"yellow-6": `Kgvxuxcs44`,
	"purple-1": `XeUPiPs73l`,
	"purple-2": `feML9hLjvD`,
	"purple-3": `iKiDNVvcsv`,
	"purple-4": `pNWQ3fB0Kj`,
	"purple-5": `qzsQS9ji9H`,
	"purple-6": `eNbG0PckOf`,
	"black-1": `EIwC1xt3kU`,
	"black-2": `M0CofJltzA`,
	"black-3": `JSvGM1GWIx`,
	"black-4": `lE_XW6QjMB`,
	"black-5": `I3MGLpQcOe`,
	"black-6": `jKP9Pvhsb9`,
	"picker-theme": `HZOTGF3200`,
	"arrow-regular": `HYkXp3xDpr`,
	"customMenuList": `qqJz55Erqe`,
	"decision-option__root": `hVMMFXWvOH`,
	"decision-option__item": `UvAxKs8cBk`,
	"decision-option__icon": `XzDV752Tab`
};
export default ___CSS_LOADER_EXPORT___;
